import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {timeout} from 'rxjs/operators';
@Injectable()
export class KerberosInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.endsWith('site_properties') || environment.isKerberos) {
            req = req.clone({
                headers: req.headers.delete('Authorization'),
                withCredentials: true
            });
        }

        return next.handle(req).pipe(timeout(1800 * 1000));
    }
}
